/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SuggestedTimesQueryRendererQueryVariables = {
    calendarIds: Array<string | null>;
    orgRelayId: string;
};
export type SuggestedTimesQueryRendererQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly personsByCalendarIdsErrorable?: {
            readonly __typename: "PersonList";
            readonly list: ReadonlyArray<{
                readonly id: string;
                readonly emails: ReadonlyArray<string>;
                readonly primaryEmail: string;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly isYou: boolean;
                readonly isOutsideOrg: boolean;
            }>;
        } | {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
        readonly workingGroups?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly rooms: ReadonlyArray<{
                        readonly roomId: string;
                        readonly name: string;
                        readonly orgId: string;
                        readonly estimatedCapacity: number | null;
                        readonly reportedCapacity: number | null;
                        readonly locationId: string | null;
                    } | null> | null;
                } | null;
            } | null> | null;
        } | undefined;
    } | null;
};
export type SuggestedTimesQueryRendererQuery = {
    readonly response: SuggestedTimesQueryRendererQueryResponse;
    readonly variables: SuggestedTimesQueryRendererQueryVariables;
};



/*
query SuggestedTimesQueryRendererQuery(
  $calendarIds: [String]!
  $orgRelayId: ID!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            isOutsideOrg
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      workingGroups(first: 1000000) {
        edges {
          node {
            id
            rooms {
              roomId
              name
              orgId
              estimatedCapacity
              reportedCapacity
              locationId
              id
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "calendarIds"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": [
            {
                "kind": "Variable",
                "name": "calendarIds",
                "variableName": "calendarIds"
            }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "personsByCalendarIdsErrorable",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "emails",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "primaryEmail",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "profile",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "givenName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "familyName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalImageUrl",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isYou",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isOutsideOrg",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "PersonList",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                    }
                ],
                "type": "GraphEntityError",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roomId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orgId",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "estimatedCapacity",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedCapacity",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationId",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SuggestedTimesQueryRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "WorkingGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "workingGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Room",
                                                            "kind": "LinkedField",
                                                            "name": "rooms",
                                                            "plural": true,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v11 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "workingGroups(first:1000000)"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SuggestedTimesQueryRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "WorkingGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "workingGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Room",
                                                            "kind": "LinkedField",
                                                            "name": "rooms",
                                                            "plural": true,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "workingGroups(first:1000000)"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "04a11583906c30780aa7828b1816f0d4",
            "id": null,
            "metadata": {},
            "name": "SuggestedTimesQueryRendererQuery",
            "operationKind": "query",
            "text": "query SuggestedTimesQueryRendererQuery(\n  $calendarIds: [String]!\n  $orgRelayId: ID!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n        __typename\n        ... on PersonList {\n          list {\n            id\n            emails\n            primaryEmail\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            isYou\n            isOutsideOrg\n          }\n        }\n        ... on GraphEntityError {\n          message\n        }\n      }\n      workingGroups(first: 1000000) {\n        edges {\n          node {\n            id\n            rooms {\n              roomId\n              name\n              orgId\n              estimatedCapacity\n              reportedCapacity\n              locationId\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'd0835cb482ab54301cc43647abd03674';
export default node;
